// @ts-nocheck
class EpBundleBuilder extends HTMLElement {
  connectedCallback() {
    this._numBoxes = parseInt(this.dataset.numBoxes || '2', 10);
    this._counts = { mani: 0, cacao: 0, chocolate_blanco: 0, caramelo: 0 };
    this._soldout = {};
    this._initSoldout();
    this._bindEvents();
    this._render();
    this._loadImages();
  }

  _initSoldout() {
    this.querySelectorAll('.ep-flavor-card').forEach(card => {
      const flavor = card.dataset.flavor;
      const available = card.dataset.available;
      if (available === 'false') {
        this._soldout[flavor] = true;
        card.classList.add('ep-flavor-card--soldout');
        // Insertar label "Agotado" encima del counter
        const body = card.querySelector('.ep-flavor-card__body');
        const counter = card.querySelector('.ep-flavor-card__counter');
        if (body && counter) {
          const label = document.createElement('span');
          label.className = 'ep-flavor-card__soldout-label';
          label.textContent = 'Agotado';
          body.insertBefore(label, counter);
        }
        // Deshabilitar el botón + permanentemente
        const plusBtn = card.querySelector('[data-action="plus"]');
        if (plusBtn) plusBtn.disabled = true;
      }
    });
  }

  async _loadImages() {
    const handleMap = {
      mani: this.dataset.handleMani,
      cacao: this.dataset.handleCacao,
      chocolate_blanco: this.dataset.handleChocolateBlanco,
      caramelo: this.dataset.handleCaramelo,
    };
    await Promise.all(
      Object.entries(handleMap).map(async ([flavor, handle]) => {
        if (!handle) return;
        try {
          const res = await fetch(`/products/${handle}.js`);
          if (!res.ok) return;
          const data = await res.json();
          if (!data.featured_image) return;
          const wrap = this.querySelector(`[data-flavor="${flavor}"] .ep-flavor-card__img-wrap`);
          if (!wrap || wrap.querySelector('img')) return;
          const img = document.createElement('img');
          img.src = data.featured_image;
          img.alt = data.title;
          img.loading = 'lazy';
          img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
          wrap.innerHTML = '';
          wrap.appendChild(img);
        } catch {}
      })
    );
  }

  get _total() {
    return Object.values(this._counts).reduce((sum, n) => sum + n, 0);
  }

  _bindEvents() {
    this.querySelectorAll('.ep-flavor-card').forEach(card => {
      const flavor = card.dataset.flavor;
      card.querySelector('[data-action="plus"]').addEventListener('click', () => {
        if (this._total < this._numBoxes) {
          this._counts[flavor]++;
          this._render();
        }
      });
      card.querySelector('[data-action="minus"]').addEventListener('click', () => {
        if (this._counts[flavor] > 0) {
          this._counts[flavor]--;
          this._render();
        }
      });
    });

    this.querySelector('.ep-bundle__cta-btn').addEventListener('click', () => this._addToCart());
  }

  _render() {
    const total = this._total;
    const remaining = this._numBoxes - total;

    this.querySelector('.ep-bundle__count').textContent = total;
    this.querySelector('.ep-bundle__progress-fill').style.width = `${(total / this._numBoxes) * 100}%`;

    this.querySelectorAll('.ep-flavor-card').forEach(card => {
      const flavor = card.dataset.flavor;
      const count = this._counts[flavor];
      const isSoldout = !!this._soldout[flavor];
      card.querySelector('.ep-flavor-card__qty').textContent = count;
      card.querySelector('[data-action="minus"]').disabled = count === 0;
      // No rehabilitar + si el sabor está agotado
      if (!isSoldout) {
        card.querySelector('[data-action="plus"]').disabled = total >= this._numBoxes;
      }
      card.classList.toggle('ep-flavor-card--active', count > 0 && !isSoldout);
    });

    const btn = this.querySelector('.ep-bundle__cta-btn');
    const complete = total === this._numBoxes;
    btn.disabled = !complete;
    btn.textContent = complete
      ? 'Agregar al carrito →'
      : `Elige ${remaining} caja${remaining !== 1 ? 's' : ''} más`;
  }

  async _addToCart() {
    const btn = this.querySelector('.ep-bundle__cta-btn');
    const errorEl = this.querySelector('.ep-bundle__error');

    const variantMap = {
      mani: this.dataset.variantMani,
      cacao: this.dataset.variantCacao,
      chocolate_blanco: this.dataset.variantChocolateBlanco,
      caramelo: this.dataset.variantCaramelo,
    };

    const items = Object.entries(this._counts)
      .filter(([, qty]) => qty > 0)
      .map(([flavor, quantity]) => ({
        id: parseInt(variantMap[flavor], 10),
        quantity,
      }));

    btn.textContent = 'Agregando...';
    btn.disabled = true;
    errorEl.classList.remove('ep-bundle__error--visible');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || 'No se pudo agregar al carrito');
      }

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (window.EpCartDrawer) {
        window.EpCartDrawer.open();
      } else {
        window.location.href = '/cart';
      }
      // Sin esto el boton quedaba en "Agregando..." y bloqueado al cerrar el carrito (2026-09-22)
      this._render();

    } catch (err) {
      errorEl.textContent = err.message;
      errorEl.classList.add('ep-bundle__error--visible');
      btn.disabled = false;
      this._render();
    }
  }
}

customElements.define('ep-bundle-builder', EpBundleBuilder);
